<template>
  <!-- 工作领导小组 -->
  <div class="page_box">
    <div class="page_option_box">
      <div></div>
      <div class="title-box">
        工作领导小组
      </div>
      <div></div>
    </div>

    <div class="page_table_box">
      <div class="school_table_box page-box">
        <el-tabs type="border-card" class="tabs-box">
          <el-tab-pane label="管理小组">
            <div class="tab-page-box">
              <div style="width: 100%;height: calc(100% - 60px);">
                <el-form
                  :model="managementGroupData"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="140px"
                  class="demo-ruleForm"
                >
                  <el-form-item label="组长:" prop="groupLeader">
                    <el-input
                      v-model.trim="managementGroupData.groupLeader"
                      style="width:80%"
                      placeholder="请输入组长"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="副组长:" prop="secondGroupLeader">
                    <el-input
                      v-model.trim="managementGroupData.secondGroupLeader"
                      style="width:80%"
                      placeholder="请输入副组长"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="成员:" prop="grouper">
                    <el-input
                      v-model.trim="managementGroupData.grouper"
                      style="width:80%"
                      placeholder="请输入成员"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="应急值班电话:" prop="dutyPhone">
                    <el-input
                      v-model.trim="managementGroupData.dutyPhone"
                      style="width:80%"
                      placeholder="请输入应急值班电话"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="save-btn-box">
                <el-button
                  type="primary"
                  size="medium"
                  @click="workGroupEdit('ruleForm')"
                  >提交保存</el-button
                >
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="管理方案">
            <div class="tab-page-box">
              <div class="page_option_box">
                文件模版:<el-link
                  type="primary"
                  @click="
                    $Common.fileDownloads(
                      'files/20200511/学校风险辨识管控制度.docx'
                    )
                  "
                >
                  <span style="font-size:16px">
                    学校风险辨识管控制度.docx
                  </span>
                </el-link>
                <el-link
                  style="margin-left:10px"
                  type="primary"
                  @click="
                    $Common.fileDownloads(
                      'files/20200511/学校双重预防体系安全生产责任制.docx'
                    )
                  "
                >
                  <span style="font-size:16px">
                    学校双重预防体系安全生产责任制.docx
                  </span>
                </el-link>
                <el-link
                  style="margin-left:10px"
                  type="primary"
                  @click="
                    $Common.fileDownloads(
                      'files/20200511/学校隐患排查治理制度.docx'
                    )
                  "
                >
                  <span style="font-size:16px">
                    学校隐患排查治理制度.docx
                  </span>
                </el-link>
                <div class="search_box">
                  <label for="oneFileUpload1">
                    <input
                      type="file"
                      id="oneFileUpload1"
                      @change="fileUpload($event, 1)"
                      accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt"
                    />
                    <span class="btn btn-success">文件上传</span>
                  </label>
                </div>
              </div>
              <div class="info-table-box" style="height:calc(100% - 60px)">
                <el-table
                  :data="fileDataList"
                  height="100%"
                  :header-cell-style="{
                    background: '#E2EEFF',
                    color: '#474859'
                  }"
                >
                  <el-table-column
                    label="序号"
                    width="70"
                    align="center"
                    type="index"
                  ></el-table-column>
                  <el-table-column
                    prop="projectName"
                    label="文件名"
                    align="center"
                    show-overflow-tooltip 
                  >
                  </el-table-column>
                  <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                      <el-link
                        type="primary"
                        @click="filePreview(scope.row.projectUrl)"
                        :underline="false"
                        >预览</el-link
                      >
                      <el-divider direction="vertical"></el-divider>
                      <el-dropdown>
                        <span class="el-dropdown-link">
                          更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item class="dropdown_item_box"
                            ><el-link
                              class="link_box"
                              type="primary"
                              @click="
                                $Common.fileDownloads(scope.row.projectUrl)
                              "
                              :underline="false"
                              >下载</el-link
                            ></el-dropdown-item
                          >
                          <el-dropdown-item class="dropdown_item_box"
                            ><el-link
                              class="link_box"
                              type="primary"
                              @click="delManagementPlan(scope.row)"
                              :underline="false"
                              >删除</el-link
                            ></el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      // 风险管理小组
      managementGroupData: {},
      // 管理方案文件列表
      fileDataList: [],
      rules: {
        groupLeader: [{ required: true, message: " ", trigger: "blur" }],
        secondGroupLeader: [{ required: true, message: " ", trigger: "blur" }],
        grouper: [{ required: true, message: " ", trigger: "blur" }],
        dutyPhone: [{ required: true, message: " ", trigger: "blur" }]
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 文件上传1
    async fileUpload(event, uploadCate = 1) {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload
      };
      const loading = this.$loading({
        lock: true,
        text: "文件上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let saveData = await this.$Http.oneFileUpload(requestData, true);
      // console.log(saveData)
      var newFileInfo = {};
      for (var testData in saveData.data) {
        newFileInfo = {
          fileName: testData,
          fileUrl: saveData.data[testData]
        };
      }
      this.oneFileUploadData = newFileInfo;

      loading.close();
      switch (uploadCate) {
        // 上传工作任务
        case 1:
          this.addWorkProject();
          break;
        // 添加岗位风险告知卡
        case 2:
          this.addNotificationCard();
          break;
        // 添加风险通告
        case 3:
          // console.log('上传风险公告');
          this.addRiskNoticePicture();
          break;
      }
    },
    // 删除风险管理方案
    async delManagementPlan(thisRowData) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        var requestData = {
          id: thisRowData.id
        };
        let saveData = await this.$Http.delManagementPlan(requestData);
        if (saveData.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.workInfo();
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "error",
            message: saveData.messsage
          });
        }
      });
    },
    // 修改管理小组信息
    workGroupEdit(formName) {
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.saveDataOption();
        } else {
          return false;
        }
      });
    },
    async saveDataOption() {
      let saveData = await this.$Http.workGroupEdit(
        this.managementGroupData,
        true
      );
      if (saveData.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: saveData.messsage
        });
      }
    },
    // 获取管控风险管理信息
    async workInfo() {
      var requestParams = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.workInfo(requestParams);
      // console.log(res.data)
      if (res.data.riskWorkGroup) {
        this.managementGroupData = {
          id: res.data.riskWorkGroup.id,
          groupLeader: res.data.riskWorkGroup.groupLeader,
          secondGroupLeader: res.data.riskWorkGroup.secondGroupLeader,
          grouper: res.data.riskWorkGroup.grouper,
          dutyPhone: res.data.riskWorkGroup.dutyPhone
        };
      }
      if (res.data.riskWorkProjects.length > 0) {
        this.fileDataList = res.data.riskWorkProjects;
      } else {
        this.fileDataList = [];
      }
    },
    // 添加风险管理方案
    async addWorkProject() {
      var requestParams = {
        schoolId: this.$store.state.schoolId,
        projectName: this.oneFileUploadData.fileName,
        projectUrl: this.oneFileUploadData.fileUrl
      };
      let saveData = await this.$Http.addWorkProject(requestParams, true);
      if (saveData.code == 200) {
        this.$message({
          type: "success",
          message: "文件上传成功"
        });
        this.workInfo();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: saveData.messsage
        });
      }
    },
    // 文件预览
    async filePreview(url) {
      if (!url) {
        this.$message({
          message: "当前文件为空，请联系管理员",
          type: "warning"
        });
      } else {
        let filePath = this.$store.state.config.fileUrl + url;
        let urlSuffix = url.split(".").pop();
        if (
          urlSuffix == "pdf" ||
          urlSuffix == "png" ||
          urlSuffix == "jpg" ||
          urlSuffix == "jpeg"
        ) {
          window.open(filePath);
        } else {
          window.open(
            "https://view.officeapps.live.com/op/view.aspx?src=" +
              encodeURIComponent(filePath)
          );
        }
      }
    }
  },
  created() {},
  mounted() {
    this.workInfo();
  }
};
</script>
<style scoped lang="scss">
@import "/css/situation_editor.css";
.title-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.page-box {
  height: 100%;
}
.page-box /deep/ .el-tabs--border-card {
  height: 100%;
}
.page-box /deep/ .el-tabs--border-card > .el-tabs__content {
  height: calc(100% - 40px);
  padding: 15px 15px 0px 15px;
}
.page-box /deep/ .el-tabs--border-card > .el-tabs__content > .el-tab-pane {
  height: 100%;
}
</style>
